<template>
<div>
<Header />
<main id="cp2025-royale">
  <div id="ancMenu">
    <ul>
      <li><a href="#cp2025-royale" class="smooth-scroll arrow-down">トップ</a></li>
      <li><a href="#product" class="smooth-scroll arrow-down">製品情報</a></li>
      <li><a href="#tech" class="smooth-scroll arrow-down">テクノロジー</a></li>
      <li><a href="#cam" class="smooth-scroll arrow-down">キャンペーン</a></li>
    </ul>
<div class="btnBlank"><a href="https://www.majesty-golf.com" target="_blank" class="arrow">ブランドサイトへ</a></div>
  </div>
  <div id="kv">
    <h1><img src="/assets/images/lp/royale-cp2025/kv_copy.svg" alt="MAJESTY Royale 飛ばしの絶頂期へ"></h1>
  </div>
  <section class="content">
    <div id="movie">
      <div class="txtArea">
        <p>こだわり世代が求めるすべての<br class="sp">
          ディスタンスパフォーマンスを<br>
          大きく進化させて誕生。<br>
          透明感のあるヘッドの輝き、<br class="sp">
          構えやすさを徹底追求。<br>
          NEW マジェスティロイヤルが、<br>
          あなたを「飛ばしの絶頂期」へと導きます。</p>
      </div>
      <div class="movieArea">
        <div class="youtube">
          <iframe width="600" height="338" src="https://www.youtube.com/embed/vgPK6Q5KGLg?si=gIl4D6SfG9ydAKm8&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <div id="releaseDay">
      <p><img src="/assets/images/lp/royale-cp2025/logo.svg" alt="NEW MAJESTY Royale"></p>
      <h2><span>2025</span>年<span>3</span>月<span>7</span>日 (金) 発売</h2>
    </div>
  </section>
  <section class="content" id="product">
    <div class="ttl">
      <p>PRODUCTS</p>
      <h2>製品紹介</h2>
    </div>
    <div class="pList">
      <div class="item">
        <div class="imgArea"><img src="/assets/images/lp/royale-cp2025/img_product01.png" alt="DRIVER"></div>
        <div class="txtArea">
          <p class="en">DRIVER</p>
          <h3>高初速ハイドロードライバー</h3>
          <p>ロフト：メンズ 9.5°,10.5°,11.5° <br class="sp">
            レディス 11.5°,12.5°</p>
          <p>¥149,600（本体 ¥136,000）</p>
        </div>
      </div>
      <div class="item reverse">
        <div class="imgArea"><img src="/assets/images/lp/royale-cp2025/img_product02.png" alt="FAIRWAYWOOD/ HYBRID"></div>
        <div class="txtArea">
          <p class="en">FAIRWAYWOOD/ HYBRID</p>
          <div class="box">
            <h3>高弾道でつかまるチタン製フェアウェイウッド</h3>
            <p>フェアウエイウッド W3,W4,W5,W7</p>
            <p> ¥99,000（本体 ¥90,000）</p>
          </div>
          <div class="box">
            <h3>ロングゲームを極める、ハイドローハイブリッド</h3>
            <p>ハイブリッド H3, H4, H5, H6</p>
            <p>¥77,000（本体 ¥70,000）</p>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="imgArea"><img src="/assets/images/lp/royale-cp2025/img_product03.png" alt="IRON"></div>
        <div class="txtArea">
          <p class="en">IRON</p>
          <h3>高初速高弾道アイアン</h3>
          <p>アイアン5本セット：￥220,000（本体￥200,000）<br>
            メンズ： No.6,7,8,9,PW　レディス：No.7,8,9,PW,SW</p>
          <p>アイアン単品：￥44,000（本体￥40,000）<br>
            メンズ：No.5, AW, SW　 レディス： No.5,6,AW</p>
        </div>
      </div>
      <div class="btnArea">
        <div class="btnAnc"><a href="#tech" class="smooth-scroll arrow-down">テクノロジーへ</a></div>
      </div>
      <div class="item reverse">
        <div class="imgArea"><img src="/assets/images/lp/royale-cp2025/img_product04.png" alt="CADDY BAG"></div>
        <div class="txtArea">
          <p class="en">CADDY BAG</p>
          <div class="box">
            <h3>芹澤信雄プロがツアーで使用するチャンピオンタイプ</h3>
            <p>￥74,800（本体：￥68,000） メンズ/9.5型/47インチ対応/5.5㎏ [CB3520]</p>
          </div>
          <div class="box">
            <h3>ホワイトとシャンパンゴールドのバイカラーが<br>
              ファッショナブルなスリムタイプ</h3>
            <p>￥63,800（本体：￥58,000） レディス/ 8.5型/47インチ対応 /3.8㎏ [CB6520]</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="content" id="tech">
    <div class="ttl">
      <p>TECHNOLOGY</p>
      <h2>テクノロジー</h2>
    </div>
    <div class="tList">
      <div class="item">
        <div class="imgArea"><img src="/assets/images/lp/royale-cp2025/img_tech02.jpg" alt="ハイペリオン チタン"></div>
        <div class="txtArea">
          <h3>ハイペリオン チタン</h3>
          <p>初速性能を追求し開発された高級希少チタン素材を採用。高強度を活かして肉薄化・軽量化し、反発エリアを拡大しました。</p>
          <div class="tag">
            <p>ドライバーに採用</p>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="imgArea"><img src="/assets/images/lp/royale-cp2025/img_tech01.jpg" alt="NEWRoyale スクエアドロー ディスタンス テクノロジー"></div>
        <div class="txtArea">
          <h3>スクエアドロー ディスタンス テクノロジー</h3>
          <p>ターゲットに対して構えやすいスクエアフェース設計。ヘッドターンを助け、つかまりの要となる慣性モーメントを高める、マルチレイヤークラッチウェイトを配置。高初速ハイドロー弾道を実現しました。</p>
          <div class="tag">
            <p>ドライバー、フェアウェイウッド、ハイブリッドに採用</p>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="imgArea"><img src="/assets/images/lp/royale-cp2025/img_tech03.jpg" alt="360° パワーフレーム / インパクトサウンド・フィーリング"></div>
        <div class="txtArea">
          <h3>360° パワーフレーム / インパクトサウンド・フィーリング</h3>
          <p>本体のたわみをコントロールし、軽量化を可能にするとともに、インパクト時の心地よい打音・打感を実現した構造。カップフェースのような効果が得られ、スイートエリアも拡大しました。</p>
          <div class="tag">
            <p>ドライバー、フェアウェイウッド、ハイブリッド、アイアンに採用</p>
          </div>
        </div>
      </div>
    </div>
    <div class="btnArea">
     <div class="btnAnc"><a href="/assets/pdf/25_Royale_Catalog_japan_0214h.pdf" target="_blank" class="arrow">カタログを見る</a></div>
    </div>
  </section>
  <section class="content" id="cam">
    <div class="ttl">
      <p>CAMPAIGN</p>
      <h2>キャンペーン</h2>
    </div>
	  <div id="camArea02">
      <div class="item">
        <div class="ttl_cam">
          <h3><img src="/assets/images/lp/royale-cp2025/logo_b.svg" alt="NEW MAJESTY Royale"></h3>
          <h2>デビューキャンペーン</h2>
        </div>
        <div class="bnrContent">
          <div class="box">
            <div class="imgArea"><img src="/assets/images/lp/royale-cp2025/bnr_img01.png" alt="パーリーゲイツとのコラボレーションによるオリジナルヘッドカバー(非売品)"></div>
            <div class="txtArea">
              <div class="copy01">
                <h4>数量限定</h4>
                <h3><span>NEW MAJESTY Royaleのドライバーをご購入いただいた方に先着で、</span><br>
                  PEARLY GATES とのコラボレーションによる<br class="pc">
                  オリジナルヘッドカバー<span>（非売品）</span>をプレゼント</h3>
                <p>※ 在庫無くなり次第終了</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <section  class="btnAreaCam">
    <div class="btnShop"> <a href="https://www.majesty-golf.com/pc/store/store-official-store" class="arrow" target="_blank">試打・ご購入は<br class="sp">最寄りのマジェスティ取扱店まで</a> </div>
  </section>
    <div id="camArea01">
      <div class="item">
        <div class="ttl_cam">
          <h3><img src="/assets/images/lp/royale-cp2025/logo_w.svg" alt="NEW MAJESTY Royale"></h3>
          <h2>予約購入者限定<br class="sp">
            コンボキャンペーン</h2>
          <p>期間：2025年2月7日（金）～3月6日（木）まで</p>
        </div>
        <div class="bnr"><p>終了しました</p><img src="/assets/images/lp/royale-cp2025/bnr_cam01.jpg" alt="NEW MAJESTY Royale コンボキャンペーン　新しいマジェスティ　ロイヤルをお得なコンボセットで"> </div>
        <p class="link"><a href="/assets/pdf/25RYL_tenposenyo.pdf" target="_blank">店舗様専用（コンボキャンペーン）</a></p>
      </div>
    </div>
    
  </section>
  <section  class="btnAreaCam">
	  	  <div class="btnBlank"><a href="https://www.majesty-golf.com" target="_blank" class="arrow">ブランドサイトへ</a></div>
  </section>
</main>
<Footer />
</div>
</template>

<script>
import Footer from '../footer'
import Header from '../header'

export default {
  data: function () {
    return {}
  },
  components: {
    Footer,
    Header
  }
}
</script>
